import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { ArrowRight } from "lucide-react";

const RAAD_PHOTO = "https://customer-assets.emergentagent.com/job_raad-realestate/artifacts/xek4wr2m_IMG_8542.jpeg";

export default function AboutPreview() {
  return (
    <section className="py-24 md:py-32 bg-black" data-testid="intro-section">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="grid lg:grid-cols-2 gap-12 lg:gap-20 items-center">
          <div className="relative lg:hidden">
            <img src={RAAD_PHOTO} alt="Raad Shalabi" className="w-full max-w-sm mx-auto object-cover" />
          </div>

          <div className="space-y-8">
            <div className="space-y-4">
              <div className="flex items-center gap-3">
                <div className="h-px w-12 bg-[#D4AF37]" />
                <span className="text-[#D4AF37] uppercase tracking-[0.2em] text-sm">Meet Your Agent</span>
              </div>
              <h2 className="text-4xl sm:text-5xl font-bold tracking-tight text-white">
                Raad <span className="text-[#D4AF37]">Shalabi</span>
              </h2>
            </div>

            <p className="text-xl text-zinc-300 leading-relaxed">
              The vast majority of sellers and buyers are immediately misguided and 
              mistreated the moment they open escrow. I take great pride in delivering 
              extraordinary service to all my clients and always ensure I've exhausted 
              every route possible to effectively represent my client's individual needs.
            </p>

            <p className="text-zinc-400 leading-relaxed">
              With 150+ homes sold and 15 years in the business, I've built my career 
              on honesty, market knowledge, and fighting for my clients. I speak English, 
              Spanish, Arabic, and Portuguese — because great service has no language barrier.
            </p>

            <div className="grid grid-cols-2 gap-6 pt-4">
              <div className="space-y-1">
                <p className="text-[#D4AF37] font-bold text-sm">Brokerage</p>
                <p className="text-white">RE/MAX TIME</p>
              </div>
              <div className="space-y-1">
                <p className="text-[#D4AF37] font-bold text-sm">License</p>
                <p className="text-white">DRE #01905641</p>
              </div>
              <div className="space-y-1">
                <p className="text-[#D4AF37] font-bold text-sm">Price Range</p>
                <p className="text-white">$138K – $1.5M</p>
              </div>
              <div className="space-y-1">
                <p className="text-[#D4AF37] font-bold text-sm">Languages</p>
                <p className="text-white text-sm">EN / ES / AR / PT</p>
              </div>
            </div>

            <Link to="/about">
              <Button
                className="bg-transparent border border-[#D4AF37] text-[#D4AF37] hover:bg-[#D4AF37] hover:text-black rounded-none font-bold uppercase tracking-widest mt-4"
                data-testid="intro-about-button"
              >
                Learn More About Me
                <ArrowRight className="w-4 h-4 ml-2" />
              </Button>
            </Link>
          </div>

          <div className="hidden lg:block relative">
            <img src={RAAD_PHOTO} alt="Raad Shalabi" className="w-full aspect-[3/4] object-cover object-top" />
            <div className="absolute inset-0 border border-[#D4AF37]/20" />
          </div>
        </div>
      </div>
    </section>
  );
}
